<template>
    <div class="filters-container">
        <q-form class='v-filter-grid'>
            <span v-for='filter in siteFilters' :key="filter.key">
                <options-filter v-if='["radio", "checkbox"].includes(filter.type)' :type='filter.type' :settings="filter" v-model="selectedFilters[filter.key]" :expanded="filter.expand"></options-filter>
                <dropdown-filter v-if='filter.type == "dropdown"' :type='filter.type' :settings="filter" v-model="selectedFilters[filter.key]" :expanded="filter.expand"></dropdown-filter>
                <slider-filter v-if='filter.type == "slider"' :type='filter.type' :settings="filter" v-model="selectedFilters[filter.key]" :expanded="filter.expand"></slider-filter>
            </span>
        </q-form>
    </div>
</template>

<script setup>
import SliderFilter from './filters/SliderFilter.vue'
import OptionsFilter from './filters/OptionsFilter.vue'
import DropdownFilter from './filters/DropdownFilter.vue'
import { useFilterStore } from "../stores/filter-store";
import { storeToRefs } from "pinia";

const filterStore = useFilterStore()
const {selectedFilters, siteFilters } = storeToRefs(filterStore)
</script>

<style lang='scss' scoped>
.v-filter-grid {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 1.2rem; 
}

@media only screen and (max-width: 767px) {
    .v-filter-grid {
        padding-top: .5rem;
    }
}
</style>